module.exports = __webpack_public_path__ + "img/docx1.3aafd2a1.png";